import { render } from "./CreditsView.vue?vue&type=template&id=162eaaf3&scoped=true"
import script from "./CreditsView.vue?vue&type=script&lang=js"
export * from "./CreditsView.vue?vue&type=script&lang=js"

import "./CreditsView.vue?vue&type=style&index=0&id=162eaaf3&lang=less&scoped=true"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162eaaf3"]])

export default __exports__